module.exports = __webpack_public_path__ + "static/media/Steve-Klein-sepia-cropped-small.dafb98e4.png";